export const SIDEBAR_WIDTH = 500
export const SIDEBAR_SPACING = 8
export const SIDEBAR_SPACING_MOBILE = 5

export const APPBAR_HEIGHT = 108
export const APPBAR_WITHOUT_MODULES_HEIGHT = 60
